const faqs = [
  {
    id: 1,
    q: '星球漫画是免费的吗？',
    a: '是的，星球漫画提供完全免费的在线漫画阅读服务。所有星际漫画、科幻漫画和宇宙漫画作品均可免费阅读，采用流畅的下拉式阅读体验，无需注册即可畅享海量漫画内容。',
  },
  {
    id: 2,
    q: '漫画更新频率如何？',
    a: '星球漫画每日更新大量漫画章节，热门连载作品保持每周至少更新一话的节奏。我们与多家漫画平台和创作者保持紧密合作，确保读者能够第一时间阅读到最新、最好看的科幻漫画。',
  },
  {
    id: 3,
    q: '支持哪些设备阅读？',
    a: '星球漫画完美适配电脑、平板和手机等各类设备。无论是在桌面端浏览还是移动端阅读，都能获得清晰流畅的下拉式漫画阅读体验。手机端更有专门的移动阅读优化，随时随地畅读。',
  },
  {
    id: 4,
    q: '如何找到好看的科幻漫画？',
    a: '你可以通过首页的漫画分类浏览不同题材（星际战争、太空冒险、外星文明等），也可以参考人气榜单和读者热评来发现优秀作品。我们的焦点专题每周精选热门漫画，帮你快速找到心头好。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            常见问答
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            关于星球漫画，你可能想了解的问题
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/60"
            >
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-question-answer-line"></i>
                  </span>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-7">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}